import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';

const googleAdsKeys = [
  'google_ads_gtm_id',
  'google_analytics_gtm_id',
  'gtm_id',
];

export const GoogleAdsSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.FRONTEND)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.FRONTEND, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings.filter((s) => googleAdsKeys.includes(s.key)))
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '95%',
      }}
    >
      <Waiting open={loading} />

      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Google
      </Typography>
      <Divider />

      <SettingsRow
        name='Google Ads GTM ID'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'google_ads_gtm_id')}
        onChange={(newValue) => handleChange('google_ads_gtm_id', newValue)}
      />

      <SettingsRow
        name='Google Analytics GTM ID'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'google_analytics_gtm_id')}
        onChange={(newValue) =>
          handleChange('google_analytics_gtm_id', newValue)
        }
      />

      <SettingsRow
        name='Master GTM ID'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'gtm_id')}
        onChange={(newValue) => handleChange('gtm_id', newValue)}
      />

      <Box sx={{ display: 'flex', flexGrow: 1 }} />

      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
